export const TITLE = 'Office address';
export const DB_PREFIX = 'officeAddress';
